import builder from '../builder';
import RealEstateActionHouseCheck from '../../streamline-icons/bold/real-estate-action-house-check.svg';

export default builder(
  'IconRealEstateActionHouseCheckBold',
  RealEstateActionHouseCheck,
);
